import { debounce, noop } from 'lodash-es';

import ReactQuill, { QuillOptionsStatic } from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './style.scss';
const modules: QuillOptionsStatic['modules'] = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'image'],
  ],
};
const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'indent',
  'link',
  'image',
];

interface RichTextEditorProps {
  name?: string;
  value?: string;
  readOnly?: boolean;
  onChange?: (value: string) => void;
}

const Editor = ({
  readOnly = false,
  onChange = noop,
  value = '',
  name,
}: RichTextEditorProps) => {
  // https://css-tricks.com/the-difference-between-throttling-and-debouncing/
  onChange = debounce(onChange, 500);
  return (
    <div className='rich-text-container'>
      <ReactQuill
        data-cy={name}
        className={readOnly ? 'quill-disabled' : undefined}
        style={{
          overflowY: 'auto',
          alignItems: 'center',
          marginBottom: 10,
          opacity: readOnly ? 0.7 : 1,
        }}
        {...{ modules, formats, value, readOnly }}
        onChange={onChange}
        bounds={`.rich-text-container`}
      />
    </div>
  );
};

export default Editor;
